import localCache from '@/utils/cache'
import router from '@/router'
import type { RouterVo } from '@/api/vo/user-vo'

/**
 * 收集动态菜单路由名称（menuType === 'C'）
 */
function collectRouteNames(menus: RouterVo[] = [], names: string[] = []): string[] {
  for (const menu of menus) {
    if (menu.menuType === 'C' && menu.name) {
      names.push(String(menu.name))
    }
    if (menu.children?.length) {
      collectRouteNames(menu.children, names)
    }
  }
  return names
}

/**
 * 移除登录时动态注册的路由
 */
export function removeDynamicRoutes(userMenus: RouterVo[] = []) {
  const names = collectRouteNames(userMenus)
  names.forEach((name) => {
    if (router.hasRoute(name)) {
      router.removeRoute(name)
    }
  })
}

/**
 * 清理本地会话缓存（不含 vuex，避免 request 与 store 循环依赖）
 */
export function clearSessionCache() {
  localCache.deleteCache('token')
  localCache.deleteCache('userInfo')
  localCache.deleteCache('userMenus')
  localCache.deleteCache('tabList')
  localCache.deleteCache('firstMenu')
}
